import React from 'react';
/**
 * @description Custom hook for auto scroll to the first error of the form.
 * @component useAutoScroll
 * @returns {ref, scrollToFirstError} scrollToFirstError
 */
var useAutoScroll = function () {
    var ref = React.useRef(null);
    /**
     * @function scrollToFirstError
     * @description Function which auto scrolls the user to the first error on that page
     * @returns void
     */
    var scrollToFirstError = function () {
        /* setTimeout helps to get updated values of form error states */
        setTimeout(function () {
            var _a, _b, _c;
            var firstErrorElement = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll("[data-error=\"error\"]");
            /*
               if an error element is found it scrolls the user to the first error element and focus on it
            */
            if (firstErrorElement && (firstErrorElement === null || firstErrorElement === void 0 ? void 0 : firstErrorElement.length) > 0) {
                (_b = firstErrorElement[0]) === null || _b === void 0 ? void 0 : _b.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'start',
                });
                (_c = firstErrorElement[0]) === null || _c === void 0 ? void 0 : _c.focus({
                    preventScroll: true,
                });
            }
        }, 100);
    };
    return { ref: ref, scrollToFirstError: scrollToFirstError };
};
export default useAutoScroll;
